import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHighSeverityErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 5,
			fill: "#FF4E4E"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 3,
			width: 2,
			height: 6,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 10.5645,
			width: 2,
			height: 2,
			rx: 1,
			fill: "white"
		})
	]
});
export default SvgHighSeverityErrorIcon;
